import { LOCAL_STORAGE_KEYS } from 'app/shared/util/local-storage-keys';

export const openFileInNewWindow = (url: string) => {
  window.open(url, '_blank');
  localStorage.setItem(LOCAL_STORAGE_KEYS.FILE_OPENED_FROM, location.href);
}
